import React from 'react';
import './css/Navbar.css';

function Navbar() {

  const handleNavItemClick = (e) => {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute('href').slice(1);
    const targetEl = document.getElementById(targetId);
    targetEl.scrollIntoView({behavior: 'smooth'});
  }

  return (
    <nav>
      <div className="title">Ernest-Hanson</div>
      <ul className="menu-items">
        <li><a href="#home" onClick={handleNavItemClick}>Home</a></li>
        <li><a href="#about" onClick={handleNavItemClick}>About</a></li>
        <li><a href="#services" onClick={handleNavItemClick}>Services</a></li>
        <li><a href="#projects" onClick={handleNavItemClick}>Projects</a></li>
        <li><a href="#contact" onClick={handleNavItemClick}>Contact</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
